import { Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TeamAttendanceModel } from '@app/models/fmsmodel/fault.model';
import { AssignmentService } from '@app/services/failure/assignment.service';
import { SharedService } from '@app/services/shared.service';
import { CommonHelper } from '@app/shared/helpers/common.helper';

@Component({
  selector: 'statusbarControl',
  templateUrl: './statusbar-control.component.html',
  styleUrls: ['./statusbar-control.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class StatusbarControlComponent {
  @ViewChild('p') popOver;
  @Input() popupContent;
  @Input() completeFaultObject;
  @Input() props;
  @Input() type;
  counter = 0;
  flag = false;

  statusForm: FormGroup = this._fb.group({
    respondedDate: [],
    respondedTime: [],
    arrivedDate: [],
    arrivedTime: [],
    startedDate: [],
    startedTime: [],
    endedDate: [],
    endedTime: [],
    failureStatus: [],
    failureCode: []
  });

  get respondedDateValue() { return this.statusForm.get('respondedDate') };
  get respondedTimeValue() { return this.statusForm.get('respondedTime') };
  get arrivedDateValue() { return this.statusForm.get('arrivedDate') };
  get arrivedTimeValue() { return this.statusForm.get('arrivedTime') };
  get startedDateValue() { return this.statusForm.get('startedDate') };
  get startedTimeValue() { return this.statusForm.get('startedTime') };
  get endedDateValue() { return this.statusForm.get('endedDate') };
  get endedTimeValue() { return this.statusForm.get('endedTime') };

  constructor(
    private _fb: FormBuilder,
    public _cmHelper: CommonHelper,
    private _sharedService: SharedService,
    private _assignmentService: AssignmentService) { }

  myScript() {
    document.getElementById("test").style.color = "yellow";
  }

  getClass(i: number): string {
    if (i === this.props.currentStep && this.props.steps[i].complete) {
      return 'current blue-bar'
    }
    if (i === this.props.currentStep) {
      return 'current';
    }
    if (this.props.steps[i].complete) {
      return this.type == 'square' ? 'complete blue-bar' : 'complete-circle blue-bar';
    }
    return this.type == 'square' ? 'incomplete' : 'incomplete-circle';
  }

  openPopFaultType(pop: any) {
    pop.isOpen() ? pop.close() : pop.open();

  }
  onEditPopup(i) {
    this.props.steps[i].edited = true;
    this.flag = true;
    console.log(this.statusForm)
  }
  onSavePopup(i, pop: any) {
    let tempModel = new TeamAttendanceModel;
    tempModel.mode = 2;
    tempModel.teamAttendanceId = this.popupContent.teamAttendanceId,
      tempModel.ifcId = this.completeFaultObject.ifcId,
      tempModel.faultId = this.completeFaultObject.faultId,
      tempModel.attendOrgUnitId = this.popupContent.attendOrgUnitId,
      tempModel.assignmentId = this.completeFaultObject.assignments[0].faultAssignmentId,
      tempModel.disId = this.popupContent.disId,
      tempModel.teamsId = this.popupContent.teamsId,
      tempModel.personId = this.popupContent.personId,
      tempModel.personName = this.popupContent.personName,
      tempModel.teamAllocatedDateTime = this.popupContent.teamAllocatedDateTime,
      tempModel.reAllocatedDateTime = this.popupContent.reAllocatedDateTime,
      tempModel.tfcRaisedStatusId = this.popupContent.tfcRaisedStatusId,
      tempModel.assignmentStatus = null,
      tempModel.activeStatusId = this.popupContent.activeStatusId,
      tempModel.teamListStatus = this.popupContent.teamListStatus,
      tempModel.advisedDateTime = this.respondedDateValue?.value && this.respondedTimeValue?.value ? this._cmHelper.setDateTime(this.respondedDateValue?.value, this.respondedTimeValue?.value) : this.popupContent.advisedDateTime,
      tempModel.availableDateTime = this.popupContent.availableDateTime,
      tempModel.eta = this.popupContent.eta,
      tempModel.arrivalSiteDateTime = this.arrivedDateValue?.value && this.arrivedTimeValue?.value ? this._cmHelper.setDateTime(this.arrivedDateValue?.value, this.arrivedTimeValue?.value) : this.popupContent.arrivalSiteDateTime,
      tempModel.commencedDateTime = this.startedDateValue?.value && this.startedTimeValue?.value ? this._cmHelper.setDateTime(this.startedDateValue?.value, this.startedTimeValue?.value) : this.popupContent.commencedDateTime,
      tempModel.completedDateTime = this.endedDateValue?.value && this.endedTimeValue?.value ? this._cmHelper.setDateTime(this.endedDateValue?.value, this.endedTimeValue?.value) : this.popupContent.completedDateTime,
      tempModel.leftSiteDateTime = null,
      tempModel.placeId = this.popupContent.placeId,
      tempModel.userId = 1

    this._assignmentService.postAssignmentTeam(tempModel).subscribe(res => {
      if (res) {
        console.log(res);
        this.props.steps[i].edited = false;
        this._sharedService.reloadAssignment$.next({ isreload: true });
        this.popOver.close();
      }
    }, error => {
      console.log('Error createAssignment:', error);
    })
  }

}
